<template>
  <v-form @submit.prevent="submitReferrerDetails" class="d-flex justify-center flex-column" :class="!$vuetify.breakpoint.smAndUp && 'w-100'">
    <div class="mt-8">
      <DOBPicker label="Date of Birth" v-model="form.birthday" class="text-field-styling" />
    </div>

    <div class="my-4">
      <p class="mb-2">{{ $t('label.gender') }}</p>
      <v-radio-group v-model="form.gender" row class="mt-0">
        <v-radio :label="$t('label.male')" value="1"></v-radio>
        <v-radio :label="$t('label.female')" value="2"></v-radio>
      </v-radio-group>
    </div>

    <v-card-actions class="d-flex flex-column align-stretch px-4">
      <v-btn color="primary" class="mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" type="submit" :loading="loading" :disabled="!validForm">
        {{ $t('next') }}
      </v-btn>
      <v-btn class="align-self-center primary--text" icon fab @click="$emit('prev-step')"><LeftArrow /></v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapMutations } from 'vuex'

import LeftArrow from '@/assets/icons/left-arrow-circle.svg'
import DOBPicker from '@/components/DOBPicker.vue'

export default {
  components: { DOBPicker, LeftArrow },

  data: () => ({
    loading: false,
    form: {
      gender: null,
      birthday: null
    }
  }),

  computed: {
    referralCodeErrors() {
      const errors = []
      this.submissionErrors.referralCode && errors.push(this.submissionErrors.referralCode)
      return errors
    },
    validForm() {
      return this.form.gender && this.form.birthday
    }
  },

  methods: {
    ...mapMutations('common', ['saveForm']),
    async submitReferrerDetails() {
      this.loading = true
      this.saveForm(this.form)
      this.$emit('next-step')
    }
  }
}
</script>
